import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      {/* Company Logo */}
      <div className="flex items-center justify-center mb-6">
        <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center shadow-elevation-2">
          <svg
            viewBox="0 0 24 24"
            className="w-8 h-8 text-primary-foreground"
            fill="currentColor"
          >
            <path d="M12 2L2 7v10c0 5.55 3.84 9.74 9 11 5.16-1.26 9-5.45 9-11V7l-10-5z"/>
            <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" fill="none"/>
          </svg>
        </div>
      </div>

      {/* Company Name and Tagline */}
      <div className="space-y-2">
<h1 className="text-xl sm:text-2xl font-bold text-foreground">
          NijanandTextile
        </h1>
<p className="text-sm sm:text-base text-muted-foreground">
          Enterprise Resource Planning System
        </p>
        <div className="flex items-center justify-center space-x-2 mt-4">
          <div className="w-2 h-2 bg-success rounded-full"></div>
          <span className="text-xs text-success font-medium">System Online</span>
        </div>
      </div>

      {/* Welcome Message */}
      <div className="mt-6 p-4 bg-primary/5 rounded-lg border border-primary/10">
        <h2 className="text-lg font-semibold text-foreground mb-1">
          Welcome Back
        </h2>
        <p className="text-sm text-muted-foreground">
          Sign in to access your textile manufacturing dashboard
        </p>
      </div>

      {/* Security Badge */}
      <div className="flex items-center justify-center space-x-2 mt-4 text-xs text-muted-foreground">
        <Icon name="Shield" size={14} color="var(--color-success)" />
        <span>Secured with 256-bit SSL encryption</span>
      </div>
    </div>
  );
};

export default LoginHeader;